import { Card, CardMedia, Typography } from "@mui/material";
import { imageWrapperStyles } from "./styles";

interface IProps {
  iconUrl: string;
  title: string;
  description: string;
}

const CharacteristicCard: React.FC<IProps> = ({
  iconUrl,
  title,
  description,
}) => {
  return (
    <Card variant="outlined" sx={{ border: "none", textAlign: "center" }}>
      <CardMedia
        component="img"
        image={iconUrl}
        alt={title}
        sx={imageWrapperStyles}
      />
      <Typography variant="h4" component="h3" color="text.primary" mb={1}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description}
      </Typography>
    </Card>
  );
};

export default CharacteristicCard;
